
import { Vue, Component, Prop } from 'vue-property-decorator';
import api from '@/api/course';

@Component
export default class AssetBox extends Vue {
  private flag: boolean = false;

  private cover: string = '';

  private timer: any;

  private controlImg: string = '';

  public $refs!: {
    audio: HTMLAudioElement,
  };

  @Prop() boxConf: any;

  mounted() {
    /* eslint-disable global-require */
    this.controlImg = this.boxConf.type === 'sound' ? require('../../icons/play.png')
      : require('../../icons/faxian.png');
  }

  /**
   * @author  Terry
   * @description 如果是声音素材则默认显示本地图片
   * @returns string
   */
  compBoxCover(): string {
    /* eslint-disable global-require */
    if (this.boxConf.type === 'sound') return require('../../icons/sound-bg.png');
    return this.boxConf.data;
  }

  /**
   * @author Terry
   * @description 根据类型得到icon路径
   * @returns string icon路劲
   */
  compBoxType(): string {
    /* eslint-disable global-require */
    switch (this.boxConf.type) {
      case 'sprite': return require('../../icons/sprite.svg');
      case 'sound': return require('../../icons/sound.svg');
      case 'background': return require('../../icons/background.svg');
      default: return '';
    }
  }

  /**
   * @author Terry
   * @description 封面改变事件
   * @param { boolean } 是开始 还是暂停
   */
  handleCoverChange(flag: boolean) {
    if (this.boxConf.type === 'sound') {
      if (flag) {
        this.$refs.audio.play();
        this.controlImg = require('../../icons/pause.png');
      } else {
        this.$refs.audio.pause();
        this.controlImg = require('../../icons/play.png');
      }
    }
    if (this.boxConf.type === 'background' || this.boxConf.imgs.length <= 1) return;
    this.flag = flag;
    if (!flag) clearInterval(this.timer);
    else {
      let i: number = 0;
      this.cover = this.boxConf.imgs[i];
      this.timer = setInterval(() => {
        /* eslint-disable no-plusplus */
        if (++i === this.boxConf.imgs.length) i = 1;
        this.cover = this.boxConf.imgs[i];
      }, 240);
    }
  }

  /**
   * @author Terry
   * @description 删除素材
  */
  handleRemoveAsset() {
    this.confirm(`你确定要删除 ${this.boxConf.title} 吗?`, {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeAssetById(this.boxConf.id, this.boxConf.cid).then(() => {
        this.$emit('getData', this.boxConf.cid);
        close();
        this.$log({
          title: '课包详情 - 删除 - 确定',
          component: 'course/chapter/question',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '课包详情 - 删除 - 取消',
      component: 'course/chapter/question',
    }));
  }
}
